<template>
  <div class="flex flex-col items-center justify-center px-6 py-14 text-center" role="alert">
    <div class="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl" :class="forbidden || notFound ? 'bg-amber-50 text-amber-500 dark:bg-amber-500/10' : 'bg-rose-50 text-rose-500 dark:bg-rose-500/10'">
      <AppIcon :name="forbidden ? 'lock' : 'alert'" :size="26" />
    </div>
    <h3 class="text-base font-bold text-slate-800 dark:text-slate-100">{{ title }}</h3>
    <p class="mt-1 max-w-md text-sm text-slate-500 dark:text-slate-400">{{ error.message }}</p>
    <AppButton v-if="retry && !forbidden && !notFound" class="mt-4" variant="outline" size="sm" icon="refresh" @click="$emit('retry')">Réessayer</AppButton>
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'
import AppButton from './AppButton.vue'

export default {
  name: 'ErrorState',
  components: { AppIcon, AppButton },
  props: {
    error: { type: Object, required: true },
    retry: { type: Boolean, default: true }
  },
  emits: ['retry'],
  computed: {
    forbidden() {
      return this.error.status === 403
    },
    notFound() {
      return this.error.status === 404
    },
    title() {
      if (this.forbidden) return 'Accès non autorisé'
      if (this.notFound) return 'Introuvable'
      if (this.error.status === 0) return 'Serveur injoignable'
      return 'Une erreur est survenue'
    }
  }
}
</script>
